import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=4a3ae3d8&"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports